import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Button, DataTable } from '../../../../ui';
import { ContextMenu } from '../../../../ui/components/Common/ContextMenu/ContextMenu';
import { useOrganizationUsers } from '../hooks';

export const UsersTab: React.FC = () => {
  const users = useOrganizationUsers();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 900, color: 'text.primary', letterSpacing: '-0.03em', mb: 0.5 }}>
            Organization Users
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
            Manage and invite team members to this organization.
          </Typography>
        </Box>
        <Button
          label="Invite User"
          variant="primary"
          sx={{ borderRadius: 3, px: 3, py: 1.25, fontWeight: 700, boxShadow: "0 10px 15px -3px rgba(16, 185, 129, 0.2)" }}
        />
      </Box>

      <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
        <DataTable
          columns={users.columns}
          data={users.users}
          rowsPerPage={10}
          totalRecords={users.users.length}
          totalPages={1}
          currentPage={1}
          onPageChange={() => {}}
        />
      </Paper>
      {users.anchorEl && users.selectedUser && (
        <ContextMenu
          anchorEl={users.anchorEl}
          onClose={users.handleCloseMenu}
          row={users.selectedUser}
          menuItems={users.menuItems}
        />
      )}
    </Box>
  );
};
